(function() {
    'use strict';

    angular.module('app')

        .service('App', App);

    /* @ngInject */
    function App($q) {

        var model = this;

        // sidebar
        model.sidebar = false;
        model.toggleSidebar = toggleSidebar;
        model.logout = logout;

        // modules
        model.module = '';
        model.page = '';
        model.modules = [];

        // auth
        model.login = login;
        model.signup = signup;
        model.logout = logout;
        model.forgot = forgot;

        function toggleSidebar(){
            model.sidebar = !model.sidebar;
        }

        function login(data){
            return $q(function(resolve, reject){
                resolve('login');
            });
        }
        function signup(data){
            return $q(function(resolve, reject){
                resolve('signup');
            });
        }
        function logout(){
            return $q(function(resolve, reject){
                resolve('logout');
            });
        }
        function forgot(data){
            return $q(function(resolve, reject){
                resolve('forgot');
            });
        }

    }

})();